import { currentPage, slug, icap, tr } from '../global-pure.js'

const TryItNowLink = ({ text = icap(tr('try it now')), url }) => {
  return (<a href={url} target='_blank'>{text}</a>)
}

export default TryItNowLink